/// <amd-module name="Reporting/Visuals/LayoutComponents/Widgets/LayoutStore" />
import { LayoutActions } from "Widgets/LayoutActions";
import { LayoutState } from "Widgets/LayoutState";

import * as VSSStore from "VSS/Reflux/Store";

/**
 * The store is responsible for managing layout state and notifies react on state changes.
 */
export class LayoutStore extends VSSStore.Store {
    protected _state: LayoutState;
    protected _actions: LayoutActions;
    protected _receivedDataHandler: (data: LayoutState) => void;

    constructor(actions: LayoutActions, initialState: LayoutState) {
        super("");
        this._actions = actions;
        this._state = initialState;
        this._receivedDataHandler = (data: LayoutState) => this._receivedData(data);
        this._actions.ProvideData.addListener(this._receivedDataHandler);
    }

    public getState(): LayoutState {
        return this._state;
    }

    public setState(state: LayoutState): void {
        this._state = state;
    }

    private _receivedData(state: LayoutState) {
        this._state = state;
        this.emitChanged();
    }
}
